
export const getTaskStatus = (tasks) => {
    if (!tasks || !Array.isArray(tasks) || tasks.length === 0) return null;

    const pendingTasks = tasks.filter((task) => task.status === "pending" && task.dueDate);
    if (pendingTasks.length === 0) return null;

    const now = new Date().getTime();
    const pendingDueDates = pendingTasks
        .map((task) => new Date(task.dueDate).getTime())
        .filter((time) => Number.isFinite(time));

    if (pendingDueDates.length === 0) return null;

    const hasOverdue = pendingDueDates.some((time) => time < now);
    if (hasOverdue) return "overdue";

    const hasUpcoming = pendingDueDates.some((time) => {
        const diff = time - now;
        return diff >= 0 && diff <= 24 * 60 * 60 * 1000;
    });

    if (hasUpcoming) return "upcoming";

    return "normal";
};
